export default __webpack_public_path__ + "static/media/sponsor-bg-1-cn.fd45480b.webp";